export default __webpack_public_path__ + "static/theme-picker-8ddf734e11ecfa5966455506e12feec1.png";